import axios from "axios";

import {
    aggregatePerformanceToSummary,
    buildTradersDatasetFromSummaryRows,
} from "../../pages/b2b/traders/buildTradersDataset";
import { withDefaultTradersDates } from "./b2bDates";
import { apiClient } from "./client";
import type {
    B2BExpoDatasetResponse,
    B2BTradersDatasetParams,
    B2BTradersDatasetResponse,
    ExpoTraderPerformanceRow,
} from "./types";

async function fetchExpoChunk(params: B2BTradersDatasetParams, performancePage: number) {
    const response = await apiClient.get<B2BExpoDatasetResponse>("/b2b/expo", {
        params: {
            date_from: params.dateFrom,
            date_to: params.dateTo,
            ...(params.traderName ? { trader_name: params.traderName } : {}),
            routes_page: 1,
            routes_per_page: 1,
            performance_page: performancePage,
            performance_per_page: 100,
        },
    });

    return response.data;
}

async function fetchAllExpoPerformance(
    params: B2BTradersDatasetParams
): Promise<{ rows: ExpoTraderPerformanceRow[]; periodFrom?: string; periodTo?: string; error?: string }> {
    const collected: ExpoTraderPerformanceRow[] = [];
    let page = 1;
    let lastPage = 1;
    let periodFrom: string | undefined;
    let periodTo: string | undefined;
    let error: string | undefined;

    do {
        const chunk = await fetchExpoChunk(params, page);

        periodFrom = chunk.periodFrom ?? periodFrom;
        periodTo = chunk.periodTo ?? periodTo;
        error = chunk.error ?? error;
        collected.push(...chunk.traderPerformance);
        lastPage = chunk.performancePagination?.last_page ?? 1;
        page += 1;
    } while (page <= lastPage);

    return { rows: collected, periodFrom, periodTo, error };
}

/** Fallback when `/b2b/traders` липсва на сървъра — агрегира от `/b2b/expo`. */
export async function fetchB2BTradersDatasetViaExpo(
    params: B2BTradersDatasetParams
): Promise<B2BTradersDatasetResponse> {
    const normalized = withDefaultTradersDates(params);
    const { rows, periodFrom, periodTo, error } = await fetchAllExpoPerformance(normalized);
    const traders = aggregatePerformanceToSummary(rows);

    return buildTradersDatasetFromSummaryRows(traders, {
        page: normalized.page ?? 1,
        perPage: normalized.perPage ?? 10,
        periodFrom,
        periodTo,
        error,
    });
}

export function shouldFallbackTradersRequest(error: unknown) {
    return axios.isAxiosError(error) && [404, 405].includes(error.response?.status ?? 0);
}
